import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaInstagram, FaEnvelope, FaWhatsapp } from "react-icons/fa"; // Importa los iconos necesarios

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-dark text-white py-2 fixed-bottom shadow-lg">
      <Container>
        <Row className="justify-content-center align-items-center text-center g-1">
          <Col xs={8} md={4} className="mb-0">
            <a
              href="mailto:contacto@sudamrc2027.cl"
              className="btn btn-outline-light btn-sm fw-bold shadow-sm px-2 py-1 small"
            >
              <FaEnvelope className="me-2" /> contacto@sudamrc2027.cl
            </a>
          </Col>
          <Col xs={4} md={4}>
            <a
              href="https://www.instagram.com/sudamrc2027"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white fs-4 mx-2"
            >
              <FaInstagram />
            </a>
            <a
              href="https://wa.me/569XXXXXXXX" // Reemplaza las X con el número real después del código de país (569)
              target="_blank"
              rel="noopener noreferrer"
              className="text-white fs-4 mx-2"
            >
              <FaWhatsapp />
            </a>
            {/* Puedes añadir más iconos de redes sociales aquí */}
          </Col>
          <Col xs={12} md={4} className="mb-1 mb-md-0">
            <p className="mb-0 text-white-50 small">
              &copy; {currentYear} Sudamericano de Automodelismo RC.
            </p>
            <p className="mb-0 text-white-50 small d-none d-md-block">
              Todos los derechos reservados. Calama, Chile.
            </p>
            <p className="mb-0 text-white-50 extra-small">
              Desarrollado por:{" "}
              <a
                href="mailto:bernardpena@gmail.com"
                className="text-white-50 text-decoration-none fw-bold"
              >
                bernardo5
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
